import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export class OnboardingChecklistController extends Controller {
  static values = { dismissUrl: String }

  dismiss () {
    post(this.dismissUrlValue)

    this.element.style.transition = 'opacity 200ms ease-out'
    this.element.style.opacity = '0'
    this.element.addEventListener('transitionend', () => this.element.remove(), { once: true })
  }
}
